"use client";

import styles from "./LocaleSwitcher.module.css";
import { useTransition } from "react";
import { useLocale } from "@/context/LocaleContext";

export default function LocaleSwitcher() {
  const [, startTransition] = useTransition();
  const { locale, setLocale } = useLocale();

  const switchLocale = (locale: "ru" | "en") => {
    startTransition(() => {
      setLocale(locale);
    });
  };

  return (
    <div>
      {locale == "ru" && (
        <span className={styles.btn} onClick={() => switchLocale("en")}>
          Ру
        </span>
      )}
      {locale == "en" && (
        <span className={styles.btn} onClick={() => switchLocale("ru")}>
          En
        </span>
      )}
    </div>
  );
}
